import { useParams } from "react-router-dom";

import { RegisteredEventHomepageView } from "event/play/views/RegisteredEventHomepageView";

import { useSavedEvent } from "event/hooks/useSavedEvent";
import { useGetEventQuery } from "event/api/event.api";
import { LoadingOverlay, Stack } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Footer } from "../components/Footer";
import { EventRegisterFormV2 } from "../components/EventRegisterFormV2";

// Helper function to find how many event features are enabled

function getEnabledFeatureCount(data: Record<string, any>): {
  total: number;

  featureKey?: string;
} {
  let totalEnabled = 0;

  let onlyEnabledKey: string | undefined;

  function searchFeatures(obj: any): void {
    if (typeof obj !== "object" || obj === null) return;

    for (const [key, value] of Object.entries(obj)) {
      if (key.endsWith("_display") && value === true) {
        totalEnabled++;

        if (totalEnabled === 1) {
          onlyEnabledKey = key;
        } else {
          onlyEnabledKey = undefined; // More than one, so discard
        }
      } else if (typeof value === "object") {
        searchFeatures(value);
      }
    }
  }

  searchFeatures(data);

  return { total: totalEnabled, featureKey: onlyEnabledKey };
}

export function EventHomepageView() {
  const { eventId } = useParams<{ eventId: string }>();
  const [savedEvent] = useSavedEvent(eventId!);
  const { playerId, partitionId } = savedEvent || {};
  const { data, isLoading, isSuccess } = useGetEventQuery(eventId as string);

  const navigate = useNavigate();
  const enabledFeatures = getEnabledFeatureCount(data!);

  useEffect(() => {
    if (
      isSuccess &&
      data &&
      enabledFeatures.total === 1 &&
      enabledFeatures.featureKey &&
      playerId &&
      partitionId
    ) {
      const featureKey = enabledFeatures.featureKey;

      const routeMap: Record<string, string> = {
        pronostics_display: "prono",
        selfies_display: "wall",
        questions_display: "questions",
        quiz_display: "quiz",
        bingo_game_display: "bingogame",
        html_page_display: "htmlpage",
        html_page_two_display: "htmlpage",
        crossbar_display: "crossbar",
        man_of_the_match_display: "motm",
        food_menu_display: "clickandcollect",
        pronostics_v2_display: "pronosticsv2",
      };

      const routePath = routeMap[featureKey];
      let destination = `/event/${eventId}/${routePath}`;

      // Add feature-specific IDs if they exist
      if (routePath === "wall" && data.wall_id)
        destination += `/${data.wall_id}`;
      if (routePath === "questions" && data.wall_questions_id)
        destination += `/${data.wall_questions_id}`;
      if (routePath === "quiz" && data.quiz_id)
        destination += `/${data.quiz_id}`;
      if (routePath === "bingogame" && data.bingo_game_id)
        destination += `/${data.bingo_game_id}`;
      if (routePath === "htmlpage" && data.html_page_id)
        destination += `/${data.html_page_id}`;
      if (
        routePath === "htmlpage" &&
        data.html_page_two_id &&
        data.html_page_id !== data.html_page_two_id
      )
        destination += `/${data.html_page_two_id}`;
      if (routePath === "crossbar" && data.crossbar_event_id)
        destination += `/${data.crossbar_event_id}`;
      if (routePath === "pronosticsv2" && data.pronostics_v2_id)
        destination += `/${data.pronostics_v2_id}`;
      navigate(destination, {
        state: { event: data, nav: routePath },
      });
    }
  }, [
    isSuccess,
    data,
    eventId,
    enabledFeatures,
    navigate,
    playerId,
    partitionId,
  ]);

  if (isSuccess && data) {
    return (
      <>
        {playerId && partitionId ? (
          <RegisteredEventHomepageView event={data} />
        ) : (
          <EventRegisterFormV2 event={data} />
        )}
        <Footer />
      </>
    );
  }
  return (
    <>
      <Stack
        className="h-screen justify-start"
        justify="center"
        align={"center"}
      >
        <LoadingOverlay visible={isLoading} />
      </Stack>
      <Footer />
    </>
  );
}
